"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Text/constant");
var _constant2 = require("../Theme/constant");
var _constant3 = require("../constant");
var _constant4 = require("./constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    theme: _propTypes.string,
    message: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      text: _propTypes.string.isRequired,
      cta: _propTypes.string,
      url: _propTypes.string,
      newTab: _propTypes.string,
      onClick: _propTypes.func
    }))]),
    textType: (0, _propTypes.oneOf)(_constant.ARR_TEXT_TYPE),
    // onClose: func,
    closable: _propTypes.bool,
    type: (0, _propTypes.oneOf)(_constant4.Types),
    showLeftIcon: _propTypes.bool,
    fullWidth: _propTypes.bool,
    timer: _propTypes.number,
    border: _propTypes.bool,
    borderRadius: (0, _propTypes.oneOf)(_constant2.ARR_BORDER_RADIUS),
    otherNotificationLabel: _propTypes.string,
    device: (0, _propTypes.oneOf)(_constant3.ARR_DEVICE_TYPE),
    customIcon: _propTypes.string,
    smallerPadding: _propTypes.bool,
    idConfig: (0, _propTypes.exact)({
      parentName: _propTypes.string,
      widgetName: _propTypes.string
    }),
    ctaColor: _propTypes.string,
    ctaSize: _propTypes.string,
    isBannerClickable: _propTypes.bool,
    largerPadding: _propTypes.bool,
    iconName: _propTypes.string,
    backgroundColor: (0, _propTypes.oneOf)(_constant2.ARR_COLORS),
    borderColor: (0, _propTypes.oneOf)(_constant2.ARR_COLORS),
    textColor: (0, _propTypes.oneOf)(_constant2.ARR_COLORS)
  },
  DefaultProps: {
    accessible: true,
    theme: _constant2.DEFAULT_THEME,
    // onClose: () => {},
    closable: false,
    type: 'info',
    showLeftIcon: true,
    fullWidth: false,
    timer: _constant4.DEFAULT_TIMER,
    textType: 'small',
    border: true,
    borderRadius: _constant2.ARR_BORDER_RADIUS.normal,
    otherNotificationLabel: _constant4.OTHER_NOTIF_LABEL,
    device: _constant3.DEVICE_TYPE.DESKTOP,
    smallerPadding: false,
    ctaColor: 'primaryDark',
    isBannerClickable: true,
    largerPadding: false,
    iconName: null,
    backgroundColor: null,
    borderColor: null,
    textColor: null
  }
};
exports.default = _default;